import { Container, Box, Typography, Card, CardMedia, Fade } from "@mui/material";
import PetsIcon from "@mui/icons-material/Pets";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import HikingIcon from "@mui/icons-material/Hiking";

const AboutPage = () => {
  return (
    <Box sx={{ minHeight: "calc(100vh - 64px)", py: 6 }}>
      <Container maxWidth="md">
        <Fade in timeout={800}>
          <Box sx={{ textAlign: "center", mb: 6 }}>
            <Typography
              variant="h2"
              component="h1"
              gutterBottom
              sx={{
                background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                backgroundClip: "text",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                fontWeight: 800,
                fontSize: { xs: "2.5rem", md: "3.5rem" },
              }}
            >
              About Us
            </Typography>
          </Box>
        </Fade>

        <Fade in timeout={1000}>
          <Card
            elevation={3}
            sx={{
              borderRadius: 3,
              overflow: "hidden",
              mb: 4,
            }}
          >
            <CardMedia
              component="img"
              image="/images/family-photo1.jpg"
              alt="Lucky Family"
              sx={{
                height: { xs: 300, md: 500 },
                objectFit: "cover",
              }}
            />
          </Card>
        </Fade>

        <Fade in timeout={1200}>
          <Box
            sx={{
              p: 4,
              borderRadius: 3,
              background: "linear-gradient(135deg, #667eea15 0%, #764ba215 100%)",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", mb: 3 }}>
              <PetsIcon sx={{ fontSize: 40, color: "#667eea", mr: 2 }} />
              <Typography variant="h4" fontWeight={600}>
                The Lucky Family
              </Typography>
            </Box>

            <Typography variant="body1" paragraph sx={{ fontSize: "1.1rem", lineHeight: 1.8 }}>
              We are the Lucky family - a mini Australian Shepherd named Lucky, along with
              Jiachen and Susan. Together, we make the perfect adventure trio!
            </Typography>

            <Box sx={{ display: "flex", alignItems: "center", mb: 2, mt: 4 }}>
              <LocationOnIcon sx={{ fontSize: 32, color: "#764ba2", mr: 2 }} />
              <Typography variant="h5" fontWeight={600}>
                Our Home
              </Typography>
            </Box>

            <Typography variant="body1" paragraph sx={{ fontSize: "1.1rem", lineHeight: 1.8 }}>
              We live in beautiful Seattle, Washington, where the mountains meet the sea and
              adventure is always just around the corner.
            </Typography>

            <Box sx={{ display: "flex", alignItems: "center", mb: 2, mt: 4 }}>
              <HikingIcon sx={{ fontSize: 32, color: "#667eea", mr: 2 }} />
              <Typography variant="h5" fontWeight={600}>
                What We Love
              </Typography>
            </Box>

            <Typography variant="body1" paragraph sx={{ fontSize: "1.1rem", lineHeight: 1.8 }}>
              We love traveling together, exploring the great outdoors, hiking scenic trails,
              and discovering new places. Whether it's a weekend camping trip
              or a walk through a local park, we cherish every moment spent together in nature.
            </Typography>

            <Typography variant="body1" sx={{ fontSize: "1.1rem", lineHeight: 1.8, mt: 3 }}>
              Lucky, our energetic mini Australian Shepherd, is always ready for the next
              adventure. With boundless energy and an infectious enthusiasm for life, Lucky
              brings joy to every journey we take together.
            </Typography>
          </Box>
        </Fade>
      </Container>
    </Box>
  );
};

export default AboutPage;
